import React, { useState, useEffect } from "react";
import { Button, Modal, ModalProps } from "react-bootstrap";
import { IMerchantSimple } from "../../interfaces";
import { SelectorsSettings } from "./selectors-settings";

interface SelectorsSettingsModalProps extends Omit<ModalProps, "onHide"> {
  merchant: IMerchantSimple;
  show: boolean;
  onHide: () => void;
  onSave: (updatedSelectors: any) => void;
}

export const SelectorsSettingsModal: React.FC<SelectorsSettingsModalProps> = ({
  merchant,
  show,
  onHide,
  onSave,
  ...modalProps
}) => {
  const [tempSelectors, setTempSelectors] = useState<any>(null);

  const handleUpdate = (updatedSelectors: any) => {
    setTempSelectors(updatedSelectors);
  };

  const handleSave = () => {
    if (tempSelectors) {
      // Process the data to ensure dates are properly formatted before saving
      const processedSelectors = { ...tempSelectors };

      if (processedSelectors.discoveredSelectors) {
        // Go through each action type and ensure dates are properly handled
        Object.keys(processedSelectors.discoveredSelectors).forEach(
          (actionType) => {
            const selectors =
              processedSelectors.discoveredSelectors[actionType];
            if (selectors && Array.isArray(selectors)) {
              processedSelectors.discoveredSelectors[actionType] =
                selectors.map((selector) => ({
                  ...selector,
                  // Convert lastWorked to ISO string format for consistent storage
                  lastWorked:
                    selector.lastWorked instanceof Date
                      ? selector.lastWorked.toISOString()
                      : new Date(
                          selector.lastWorked || Date.now()
                        ).toISOString(),
                }));
            }
          }
        );
      }

      onSave(processedSelectors);
    }
    onHide();
  };

  // Reset temp selectors when modal opens
  useEffect(() => {
    if (show) {
      setTempSelectors(null);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      backdrop="static"
      {...modalProps}
    >
      <Modal.Header closeButton>
        <Modal.Title>Selectors Settings - {merchant.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="selector-settings-modal-body"
        style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
      >
        <SelectorsSettings merchant={merchant} onUpdate={handleUpdate} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
